import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AttributesActions } from './attributes.actions';
import { AttributesSelectors } from './attributes.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import { Attribute } from '@emm/core/models/attribute.model';
import {AttributeType} from '@emm/core/models/attribute-type.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {SearchFilter} from '@emm/core/models/search-filter';

export interface AttributesQueries extends AsyncActionQueries {
    allGlobal$: Observable<Attribute[]>;
    all$: Observable<Attribute[]>;
    selected$: Observable<Attribute>;
    attributeTypes$: Observable<AttributeType[]>;
}

@Injectable({ providedIn: 'root' })
export class AttributesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, AttributesSelectors);
    }

    dispatch = {
        selectAttribute: (tag: string) =>
            this.store.dispatch(AttributesActions.select({ tag })),
        searchAttributes: (filter: SearchFilter) =>
            this.store.dispatch(AttributesActions.searchAttributes({ filter })),
        openAddAttributeDialog: () =>
            this.store.dispatch(AttributesActions.openAddDialog())
    };

    queries: AttributesQueries = {
        allGlobal$: this.selectNonNil(AttributesSelectors.getAllGlobal),
        all$: this.selectNonNil(AttributesSelectors.getFilteredAttributes),
        selected$: this.selectNonNil(AttributesSelectors.getSelected),
        attributeTypes$: this.select(AttributesSelectors.getAttributeTypes),
        ...this.asyncActionQueries
    };

}
